import React from 'react';
import { Box, Typography, Card, CardContent, CardActionArea } from '@mui/material';
import { MaturityBadge } from './MaturityBadge';
import { StatusIndicator } from './StatusIndicator';

/**
 * CategoryCard - Governance category card with maturity and status
 * @param {string} name - Category name
 * @param {string} description - Category description
 * @param {string} maturityLabel - Maturity level
 * @param {string} statusLabel - Status label
 * @param {function} onClick - Optional click handler (enables hover effect)
 */
export const CategoryCard = ({
  name,
  description,
  maturityLabel,
  statusLabel,
  onClick,
}) => {
  const CardWrapper = onClick ? CardActionArea : Box;

  return (
    <Card
      elevation={0}
      sx={{
        border: '1px solid #e0e0e0',
        borderRadius: 2,
        height: '100%',
        transition: 'box-shadow 0.2s',
        '&:hover': onClick ? { boxShadow: '0 4px 12px rgba(0,0,0,0.1)' } : {},
      }}
    >
      <CardWrapper onClick={onClick} sx={{ height: '100%' }}>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
            <StatusIndicator status={statusLabel} showLabel={false} />
            <MaturityBadge label={maturityLabel} size="small" />
          </Box>
          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            {name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </CardContent>
      </CardWrapper>
    </Card>
  );
};
